import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { toLocalDate, toZonedDateTime } from '@spa-frontend/date-lib';
const { moment } = new AdapterMoment();
import { withPaperElevation } from '../paper';
import { firstLetterUppercase } from '../typography';
import { deepMerge } from '../utils';
function getClearableProps(props) {
    return {
        slotProps: {
            ...props.slotProps,
            field: {
                ...props.slotProps?.field,
                clearable: !props.disableClearable,
                onClear: () => props.onChange?.(undefined)
            }
        }
    };
}
function getErrorProps(props) {
    return {
        slotProps: {
            ...props.slotProps,
            textField: {
                ...props.slotProps?.textField,
                error: Boolean(props.error),
                helperText: props.error
            }
        }
    };
}
export function useDateSlotProps(props) {
    const clearableProps = getClearableProps({
        disableClearable: props.disableClearable,
        onChange: props.onChange,
        slotProps: props.slotProps
    });
    const errorProps = getErrorProps({
        error: props.error,
        slotProps: props.slotProps
    });
    const textfieldProps = {
        slotProps: {
            textField: {
                size: props.size,
                sx: {
                    width: props.width,
                    '& .MuiInputBase-root': {
                        height: '100%'
                    },
                    'label.MuiFormLabel-root': firstLetterUppercase
                }
            }
        }
    };
    const mergedProps = deepMerge(clearableProps, errorProps, textfieldProps);
    return {
        slotProps: {
            ...mergedProps.slotProps,
            desktopPaper: withPaperElevation(mergedProps.slotProps?.desktopPaper, 'L'),
            mobilePaper: withPaperElevation(mergedProps.slotProps?.mobilePaper, 'XL')
        }
    };
}
export function toMoment(value) {
    return value ? moment(value.toDate()) : undefined;
}
toMoment.nullable = (value) => {
    return toMoment(value) ?? null;
};
export function fromMomentToZonedDateTime(value, timezone) {
    return value && timezone
        ? toZonedDateTime(value.toDate(), timezone)
        : undefined;
}
export function fromMomentToLocalDate(value) {
    return value ? toLocalDate(value.toDate()) : undefined;
}
